import {Grid} from '@primer/react-brand'

import {ContentfulCtaBanner} from '@github-ui/swp-core/components/contentful/ContentfulCtaBanner'
import type {PrimerComponentCtaBanner} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'

import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function CtaBannerSection(props: Props) {
  const {contentfulContent} = props
  const {content} = contentfulContent.fields

  const ctaBannerComponent = content?.find(item => item.sys.contentType.sys.id === 'primerComponentCtaBanner') as
    | PrimerComponentCtaBanner
    | undefined

  if (!ctaBannerComponent) {
    return null
  }

  return (
    <section id="resources" className="lp-Resources-wrapper">
      <Grid className="lp-Section-container--centerUntilMedium lp-Grid--noRowGap pb-8 pb-md-12 pt-8 pt-md-12 lp-Resources-container border-top-0">
        <Grid.Column span={12}>
          <ContentfulCtaBanner component={ctaBannerComponent} />
        </Grid.Column>
      </Grid>
    </section>
  )
}

try{ CtaBannerSection.displayName ||= 'CtaBannerSection' } catch {}